import {
  CREATE_BANNER_REQUEST,
  CREATE_BANNER_SUCCESS,
  CREATE_BANNER_FAIL,
  GET_BANNERS_REQUEST,
  GET_BANNERS_SUCCESS,
  GET_BANNERS_FAIL,
  DELETE_BANNER_REQUEST,
  DELETE_BANNER_SUCCESS,
  DELETE_BANNER_FAIL,
} from "../actionTypes";
import axiosInstance from "../../api/axiosInstance";
import { toast } from "react-toastify";

export const createBanner = (bannerData, token) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_BANNER_REQUEST });
    const response = await axiosInstance.post("/api/upload-banner/", bannerData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    console.log("Create Banner response:", response.data);
    dispatch({ type: CREATE_BANNER_SUCCESS, payload: response.data });
    toast.success(response.data.message || "Banner created successfully");
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || "Failed to create banner";
    dispatch({
      type: CREATE_BANNER_FAIL,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    console.log("Create Banner error:", error.response?.data || error.message);
    throw error;
  }
};

export const getBanners = (filters = {}, token) => async (dispatch) => {
  try {
    dispatch({ type: GET_BANNERS_REQUEST });
    const queryParams = new URLSearchParams();
    
    if (filters.client_id) queryParams.append("client_id", filters.client_id);
    if (filters.is_live !== undefined) queryParams.append("is_live", filters.is_live);
    if (filters.role_id) queryParams.append("role_id", filters.role_id);
    if (filters.banner_type) queryParams.append("banner_type", filters.banner_type);
    
    const url = `/api/banners/${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Get Banners response:", response.data);
    dispatch({ type: GET_BANNERS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || "Failed to fetch banners";
    dispatch({
      type: GET_BANNERS_FAIL,
      payload: errorMessage,
    });
    console.log("Get Banners error:", error.response?.data || error.message);
    return { banners: [], count: 0, error: errorMessage };
  }
};

export const deleteBanner = (bannerId, token) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_BANNER_REQUEST });
    const response = await axiosInstance.delete(`/api/delete-banner/${bannerId}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Delete Banner response:", response.data);
    dispatch({ type: DELETE_BANNER_SUCCESS, payload: { bannerId, data: response.data } });
    toast.success(response.data.message || "Banner deactivated successfully");
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || "Failed to deactivate banner";
    dispatch({
      type: DELETE_BANNER_FAIL,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    console.log("Delete Banner error:", error.response?.data || error.message);
    throw error;
  }
};

